'use client';

import React from 'react';

function Failed() {
  return (
    <>
      <svg
        viewBox="0 0 170 170"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        height={100}
        width={100}
      >
        <circle
          cx="85.1353"
          cy="84.7505"
          r="84.2993"
          fill="#FF2120"
          fill-opacity="0.2"
        />
        <circle
          cx="85.1359"
          cy="84.7512"
          r="68.5695"
          fill="#FF2120"
          fill-opacity="0.3"
        />
        <circle
          opacity="0.4"
          cx="85.1343"
          cy="84.7496"
          r="55.2906"
          fill="#FF312B"
          fill-opacity="0.3"
        />
        <circle
          cx="85.4506"
          cy="84.4506"
          r="38.4506"
          fill="#FF1E1E"
          fill-opacity="0.84"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M71.7976 75.3954C70.7757 74.4303 70.7297 72.8195 71.6948 71.7976C72.6599 70.7757 74.2707 70.7297 75.2926 71.6948L84.9991 80.862L94.7057 71.6948C95.7276 70.7297 97.3384 70.7757 98.3035 71.7976C99.2686 72.8195 99.2226 74.4303 98.2007 75.3954L88.7058 84.3628L98.1985 93.3281C99.2204 94.2933 99.2665 95.9041 98.3013 96.926C97.3362 97.9479 95.7254 97.9939 94.7035 97.0288L84.9991 87.8636L75.2948 97.0288C74.2729 97.9939 72.6621 97.9479 71.697 96.926C70.7318 95.9041 70.7778 94.2933 71.7997 93.3281L81.2925 84.3628L71.7976 75.3954Z"
          fill="white"
        />
      </svg>
    </>
  );
}

export default Failed;
